<script>
    import { nanoid } from 'nanoid';
    import AddressAutoComplete from './AddressAutoComplete.svelte';

    export let idPrefix = 'addr' + + nanoid(4);
    export let addressPrefix = null;
    export let googlePlaceJson = null;
    export let formattedAddress = null;
    export let premise = null;
    export let subpremise = null;
    export let street = null;
    export let suburb = null;
    export let state = null;
    export let postcode = null;
    export let country = null;
    export let lat = null;
    export let lng = null;
    export let placeId = null;
    export let url = null;
    export let disabled;
    export let required;

</script>

<AddressAutoComplete {idPrefix}
                    {addressPrefix}
                     bind:googlePlaceJson={googlePlaceJson}
                     bind:formattedAddress={formattedAddress}
                     bind:premise="{premise}"
                     bind:subpremise="{subpremise}"
                     bind:street="{street}"
                     bind:suburb="{suburb}"
                     bind:state="{state}"
                     bind:postcode="{postcode}"
                     bind:country="{country}"
                     bind:lat="{lat}"
                     bind:lng="{lng}"
                     bind:placeId="{placeId}"
                     bind:url="{url}"
                     {disabled}
                     {required}></AddressAutoComplete>
